<template>
  <div class="route-table">
    <table>
      <thead>
      <tr class="route-table__head">
        <th scope="col">
          {{ translations['bookings.routetable.route'] }}
        </th>
        <th scope="col">
          {{ translations['bookings.routetable.lowseason'] }}
        </th>
        <th scope="col">
          {{ translations['bookings.routetable.peakseason'] }}
        </th>
        <th scope="col">
          {{ translations['bookings.routetable.express'] }}
        </th>
      </tr>
      </thead>

      <tbody>
      <tr v-for="part in ticket?.distanceParts"
          :key="part.name">
        <td>{{ part.name }}</td>
        <td>{{ part.timeRequiredLowSeason }}</td>
        <td>{{ part.timeRequiredHighSeason }}</td>
        <td>{{ part.timeRequiredExpress }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import {getTranslations} from "@services/translations";

defineProps<{
  ticket: RoutePageTicketPayload;
}>();

const translations = getTranslations();

</script>
